/* COLOMBY COFFEE — product page */
(function () {
  'use strict';

  function mainPicker() {
    return document.querySelector('main .product-details variant-picker') ||
      document.querySelector('main variant-picker');
  }

  /* Roast switch ("متاح كمان بتحميص"): select the matching roast in the
     theme's own variant picker instead of reloading the whole page. The
     picker keeps the chosen size and type and updates price, photo and
     cart button in place. The link's href stays as the no-JS fallback. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cb-pdp-roast__alt a[data-roast]');
    if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    var picker = mainPicker();
    if (!picker) return;
    var target = link.getAttribute('data-roast');
    var input = null;
    picker.querySelectorAll('input[type="radio"]').forEach(function (i) {
      if (!input && i.value === target) input = i;
    });
    if (!input) {
      picker.querySelectorAll('option').forEach(function (o) {
        if (!input && o.value === target) input = o;
      });
    }
    if (!input) return;
    e.preventDefault();
    if (input.tagName === 'OPTION') {
      var select = input.closest('select');
      select.value = input.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      input.click();
    }
  });

  /* Title: "جولد" or "جولد محوّج" depending on the selected type. */
  function syncTitle() {
    var title = document.querySelector('[data-cbx-title]');
    var picker = mainPicker();
    if (!title || !picker) return;
    var spiced = false;
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
      if (i.value === 'محوج' || i.value === 'محوّج') spiced = true;
    });
    picker.querySelectorAll('select').forEach(function (s) {
      if (s.value === 'محوج' || s.value === 'محوّج') spiced = true;
    });
    var base = title.getAttribute('data-base') || '';
    var next = spiced ? base + ' محوّج' : base;
    if (title.textContent !== next) title.textContent = next;
  }

  /* Roast panel: re-render just that panel for the new variant, so the
     roast name, meters and "متاح كمان بتحميص" links follow the selection. */
  var roastCtrl = null;
  function refreshRoast() {
    var panel = document.querySelector('main .cb-pdp-roast');
    var section = panel && panel.closest('.shopify-section');
    var variant = new URLSearchParams(location.search).get('variant');
    if (!panel || !section || !variant) return;
    var sectionId = section.id.replace('shopify-section-', '');
    if (roastCtrl) roastCtrl.abort();
    roastCtrl = new AbortController();
    var url = location.pathname + '?variant=' + encodeURIComponent(variant) + '&section_id=' + encodeURIComponent(sectionId);
    fetch(url, { signal: roastCtrl.signal })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cb-pdp-roast');
        var live = document.querySelector('main .cb-pdp-roast');
        if (fresh && live) live.replaceWith(fresh);
      })
      .catch(function () {});
  }

  var pending = 0;
  var lastVariant = new URLSearchParams(location.search).get('variant');
  function scheduleSync() {
    cancelAnimationFrame(pending);
    pending = requestAnimationFrame(syncTitle);
  }
  function afterVariant() {
    syncTitle();
    var v = new URLSearchParams(location.search).get('variant');
    if (v && v !== lastVariant) {
      lastVariant = v;
      refreshRoast();
    }
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) {
      scheduleSync();
      /* The picker is re-rendered and the URL updated after the new variant arrives. */
      setTimeout(afterVariant, 450);
      setTimeout(afterVariant, 1200);
    }
  });
  window.addEventListener('pageshow', syncTitle);
})();
